import * as React from "react";
const SvgFiRrQueueLine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-queue-line_svg__a)">
      <path
        fill="#062147"
        d="M14.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M12 5c.403 0 .778-.104 1.115-.273A4.43 4.43 0 0 1 12.5 2.5c0-.815.234-1.568.614-2.227A2.5 2.5 0 0 0 12 0a2.5 2.5 0 1 0 0 5M7 5c.403 0 .778-.104 1.115-.273A4.43 4.43 0 0 1 7.5 2.5c0-.815.234-1.568.614-2.227A2.5 2.5 0 0 0 7 0a2.5 2.5 0 1 0 0 5m16.159 9.26a1.76 1.76 0 0 0-1.728-.064l-.377.195C19.297 15.303 16.028 17 11.999 17s-7.298-1.697-9.055-2.609l-.378-.195a1.75 1.75 0 0 0-1.727.064 1.75 1.75 0 0 0-.841 1.502V23a1 1 0 1 0 2 0v-6.846l.023.012c1.908.99 5.46 2.834 9.977 2.834s8.068-1.844 9.977-2.834l.023-.012V23a1 1 0 1 0 2 0v-7.238c0-.618-.314-1.18-.841-1.502zM12 14a1 1 0 1 0 2 0v-4c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2a1 1 0 1 0 2 0v-2c0-2.206-1.794-4-4-4h-2c-2.206 0-4 1.794-4 4zm-5-.5a1 1 0 1 0 2 0V10a2 2 0 0 1 1.301-1.867A6 6 0 0 1 11.54 6H11c-2.206 0-4 1.794-4 4zm-4-1a1 1 0 0 0 1-1V10a2 2 0 0 1 1.301-1.867A6 6 0 0 1 6.54 6H6c-2.206 0-4 1.794-4 4v1.5a1 1 0 0 0 1 1M4 23a1 1 0 1 0 2 0v-2.96a24 24 0 0 1-2-.721zm5 0a1 1 0 1 0 2 0v-2.048a19 19 0 0 1-2-.206zm9 0a1 1 0 1 0 2 0v-3.68c-.611.254-1.284.495-2 .721zm-4 0a1 1 0 1 0 2 0v-2.435c-.64.135-1.302.249-2 .323z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-queue-line_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrQueueLine;
